var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":"Guia CID, CIAP e SIGTAP","size":"xl","hide-footer":"","body-class":"modal-guia-codigos__body"}},[_c('iframe',{staticClass:"modal-guia-codigos__iframe",attrs:{"src":_vm.url,"title":"Guia CID, CIAP e SIGTAP"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }